import { $api } from '@service/RequestService';
import { useQuery } from 'react-query';

import { crmConstants, crmModels } from '..';

export const usePipeAll = (props: { enabled?: boolean; isNotInfinity?: boolean } = {}) => {
  const { ...args } = useQuery<crmModels.IPipeAll[]>({
    queryKey: [crmConstants.queryKeys.PIPE_ALL],
    queryFn: async () => {
      const res = await $api.get('/v1/pipe/all');

      return res?.data?.data;
    },
    staleTime: props?.isNotInfinity ? undefined : Infinity,
    enabled: props?.enabled
  });

  const dataObject = (args?.data || [])?.reduce<
    Record<string, crmModels.IPipeAll & { pipeStatuses: Record<string, crmModels.IPipeAll['pipeStatuses']> }>
  >(
    (p, pipe: crmModels.IPipeAll) => ({
      ...p,
      [pipe?.id]: {
        ...pipe,
        pipeStatuses: (pipe?.pipeStatuses || [])?.reduce(
          (statusP, pipeStatus) => ({ ...statusP, [pipeStatus?.id]: pipeStatus }),
          {}
        )
      }
    }),
    {}
  );

  return { dataObject, ...args };
};
